import { render, staticRenderFns } from "./jpreward.vue?vue&type=template&id=004a64da"
import script from "./jpreward.vue?vue&type=script&lang=js"
export * from "./jpreward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports